module.exports = __webpack_public_path__ + "static/media/img-clock@2x.b828148a.png";